// extracted by css-extract-rspack-plugin
export default {"checkboxGrid":"checkboxGrid-yioSXY","checkbox":"checkbox-UcGZmT"};